(function($, undefined) {

	'use strict';
	var doc = $(document);
	var currPage;
	var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
	var body;
	var items;
	var checkLabel;
	var checkboxItems;
	var checkboxItemsInner;
	var file;
	var fileInput;
	var formSwitch;
	var formCheck;
	var selectCountry;
	var file;
	var fileInput;
	var validateAndSubmitBtn;
	var passwordField;
	var formPopupCloseBtn;
	

	var validateForm = function (ctn, showError) {
		ctn.each(function () {
			var t = $(this);
			var toValidateItems = $('.form-input:not(.select-state-input:not(.selected)).required', t);
			var toValidateUpload = $('.form-item-upload-input.required', t);
			var toValidateCheck = $('.form-check-input.required', t);
			var toValidateWysiwyg = $('.form-wysiwyg-ctn.required', t);
			var password = $('.js-password', t);
			var passwordConfirm = $('.js-password-confirm', t);
			var email = $('.js-email', t);
			var emailConfirm = $('.js-email-confirm', t);
			var btn = $('.js-form-btn', t);
			var isOk = true;
			var passwordOk = true;
			var passwordConfirmOk = true;
			var passwordRequirementsOk = true;
			var termsOk = true;
			var checkOk = true;
			var emailOk = true;
			var wysOk = true;
			var fieldsErrorMessage = $('.js-form-error-message.fields', t);
			var fieldsErrorCheckbox = $('.js-form-error-message.checkbox', t);
			var fieldsErrorTerms = $('.js-form-error-message.terms', t);
			var fieldsErrorPassword = $('.js-form-error-message.password', t);
			var fieldsErrorEmail = $('.js-form-error-message.email-check', t);
			
			
			toValidateItems = toValidateItems.filter(function () {
				return $(this).closest('.clone').length === 0;
			});
			
			toValidateUpload = toValidateUpload.filter(function () {
				return $(this).closest('.clone').length === 0;
			});
			
			toValidateCheck = toValidateCheck.filter(function () {
				return $(this).closest('.clone').length === 0;
			});
			
			toValidateWysiwyg = toValidateWysiwyg.filter(function () {
				return $(this).closest('.clone').length === 0;
			});

			toValidateItems.each(function () {
				var tChild = $(this);
				validateField(tChild, t);
				if (tChild.hasClass('error')) {
					isOk = false;
				}
			});

			toValidateUpload.each(function () {
				var input = $(this);
				var tUpload = input.closest('.form-input-big-ctn');

				if (input.val() === '') {
					tUpload.add(input).addClass('error');
					$('.form-error-message.field', tUpload).slideDown(300);
				} else {
					tUpload.add(input).removeClass('error');
					$('.form-error-message.field', tUpload).slideUp(300);
				}

				if (tUpload.hasClass('error')) {
					isOk = false;
				}
			});

			toValidateCheck.each(function () {
				var tCheck = $(this);
				var tCtn = tCheck.closest('.form-checkbox-ctn');

				if (!tCheck.is(':checked')) {
					tCtn.addClass('error');
					
					if (tCtn.attr('name') !== 'terms') {
						checkOk = false;
					}
				} else {
					tCtn.removeClass('error');
				}

				if (tCheck.attr('name') === 'terms' && tCtn.hasClass('error')) {
					termsOk = false;
				}

				if (tCtn.hasClass('error')) {
					termsOk = false;
				}
			});

			toValidateWysiwyg.each(function() {
				var content = tinymce.get($('.form-input', $(this)).attr('id')).getContent();

				if (content === '') {
					wysOk = false;
					$(this).find('.form-input-ctn').addClass('error');
				} else {
					$(this).find('.form-input-ctn').removeClass('error');
				}
			});
			
			if (email.length !== 0 && emailConfirm.length !== 0 && (email.val() !== emailConfirm.val() || email.val().length === 0)) {
				if (email.val().length === 0) {
					email.removeClass('success').addClass('error');
					emailOk = false;
				} else {
					email.addClass('success').removeClass('error');
					emailOk = true;
				}
								
				if (email.val() !== emailConfirm.val() || (email.val().length === 0)) {
					emailConfirm.removeClass('success').addClass('error');
					emailOk = false;
				} else {
					emailConfirm.removeClass('error');
					emailOk = true;

					if (email.val().length !== 0) {
						emailConfirm.addClass('success');
					}
				}
			}
			
			if (password.hasClass('error')) {
				passwordOk = false;
			}
			if (passwordConfirm.hasClass('error')) {
				passwordConfirmOk = false;
			}
						
			t.addClass('is-checked');

			if (!termsOk) {
				fieldsErrorTerms.slideDown(300);
			} else {
				fieldsErrorTerms.slideUp(300);
			}
			
			if (!checkOk) {
				fieldsErrorCheckbox.slideDown(300);
			} else {
				fieldsErrorCheckbox.slideUp(300);
			}

			if (email.length !== 0 && emailConfirm.length !== 0) {
				if (email.length !== 0 && emailOk) {
					ctn.addClass('has-email');
					email.add(emailConfirm).removeClass('error');
					fieldsErrorEmail.slideUp(300);
				} else {
					ctn.removeClass('has-email');
					email.add(emailConfirm).addClass('error');
					fieldsErrorEmail.slideDown(300);
				}
			}
						
			if (!isOk) {
				fieldsErrorMessage.slideDown(300);
			} else {
				fieldsErrorMessage.slideUp(300);
			}

			if (!isOk || !passwordOk || !passwordConfirmOk || !passwordRequirementsOk || !termsOk || !checkOk || !emailOk || !wysOk) {
				btn.addClass('disabled');
				ctn.addClass('has-error');

				if (showError) {
					showErrorPopup();
				}

				if (!passwordOk && password.hasClass('required')) {
					ctn.addClass('error-password');
				} else {
					ctn.removeClass('error-password');
				}
				return false;
			} else {
				btn.removeClass('disabled');
				ctn.removeClass('has-error').removeClass('error-password');

				fieldsErrorTerms.slideUp(300);
				return true;
			}
		});
	};

	var validateField = function (elt, form) {
		var tag = elt[0].tagName;
		var type = elt.attr('type');
		var val = elt.hasClass('select-value') ? elt.attr('data-value') : elt.val();
		var attrClass = elt.attr('data-validator-apply-class-on');
		var classTarget = attrClass !== undefined ? elt.closest(attrClass) : elt;
		//Choises for validate are : "email", "url", "tel" or "default". By default, an input type email takes the email validation,
		//the input type tel takes the tel validation and if the validate value is "default", then it do a normal check if the input has char
		var validate = elt.attr('data-validate');
		var reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		var reUrl = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
		var reTel = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
		var emailValid = true;
		var whiteSpaceValid = true;
		var urlValid = true;
		var telValid = true;
		var inputValid = true;
		var isSelectMultiple = elt.closest('.account-multiple-select-ctn').length;

		if(!val.replace(/\s/g, '').length) {
			whiteSpaceValid = false;
		}

		if (tag === 'INPUT' && (type === 'email' || validate === 'email') && validate !== 'default') {
			emailValid = reEmail.test(val);
		} else if (tag === 'INPUT' && validate === 'url' && validate !== 'default') {
			urlValid = reUrl.test(val);
		} else if (tag === 'INPUT' && (type === 'tel' || validate === 'tel') && validate !== 'default') {
			telValid = reTel.test(val);
		} else if (elt.hasClass('form-input-upload-input')) {
			if (classTarget.add(elt).hasClass('required') && elt.val() !== '') {
				classTarget.add(elt).removeClass('error').addClass('success');
			} else {
				classTarget.add(elt).addClass('error').removeClass('success');
			}
		} else {
			classTarget.add(elt).addClass('success').removeClass('error');
			if (classTarget.hasClass('required') && $.trim(val).length === 0) {
				classTarget.add(elt).removeClass('success').addClass('error');
								inputValid = false;
			} else if (!classTarget.hasClass('required') && val.length === 0) {
				classTarget.add(elt).removeClass('success').removeClass('error');
			}
		}
		
		if (classTarget.hasClass('required') && type !== 'password') {
			if (emailValid) {
				$('.form-error-message.email', classTarget).slideUp(200);
			} else if (val.substring(0, 4) !== 'mg2-') {
				$('.form-error-message.email', classTarget).slideDown(200);
			}
			if (urlValid) {
				$('.form-error-message.url', classTarget).slideUp(200);
			} else {
				$('.form-error-message.url', classTarget).slideDown(200);
			}
			if (telValid) {
				$('.form-error-message.tel', classTarget).slideUp(200);
			} else {
				$('.form-error-message.tel', classTarget).slideDown(200);
			}
			
			if (inputValid && whiteSpaceValid) {
				$('.form-error-message.field', classTarget).slideUp(200);
			} else {
				if(emailValid && urlValid && telValid) {
					$('.form-error-message.field', classTarget).slideDown(200);
				}
			}
		}
		
		if (elt.hasClass('js-password') || elt.hasClass('js-password-confirm')) {
			validatePassword(form);
		} else {
			if (isSelectMultiple) {
				var multipleSelectCtn = elt.closest('.account-multiple-select-ctn');
				
				if ($('.account-option-item:not(.clone)', multipleSelectCtn).length) {
					classTarget.add(elt).removeClass('error').addClass('success');
				} else if (elt.hasClass('required')) {
					classTarget.add(elt).addClass('error').removeClass('success');
					//#TODO remove console log
					// console.log('input error : ' + elt.attr('name'));
				}
			} else if (emailValid && urlValid && telValid && inputValid && whiteSpaceValid) {
				classTarget.add(elt).removeClass('error').addClass('success');
			} else if (val.length === 0 && !classTarget.hasClass('required')) {
				classTarget.add(elt).removeClass('error').removeClass('success');
			} else if (type !== 'email' || (type === 'email' && val.substring(0, 4) !== 'mg2-')) {
				classTarget.add(elt).addClass('error').removeClass('success');
				//#TODO remove console log
				// console.log('input error : ' + elt.attr('name'));
			}
		}
	};
	
	var validatePassword = function (t, standalone = false) {
		var password = $('.js-password', t);
		var passwordConfirm = $('.js-password-confirm', t);
		var passwordParent =  password.closest(password.attr('data-validator-apply-class-on')) !== undefined ? password.closest(password.attr('data-validator-apply-class-on')) : password;
		var passwordConfirmParent =  passwordConfirm.closest(passwordConfirm.attr('data-validator-apply-class-on')) !== undefined ? passwordConfirm.closest(password.attr('data-validator-apply-class-on')) : password;
		
		var passwordOk = true;
		var passwordConfirmOk = true;
		var passwordRequirementsOk = true;
		
		if (password.val().length === 0) {
			passwordOk = false;
		}
		
		if (password.val() !== passwordConfirm.val()) {
			if (password.val().length === 0) {
				passwordOk = false;
			} else {
				passwordOk = true;
			}

			if (password.val() !== passwordConfirm.val() || passwordConfirm.val().length === 0) {
				passwordConfirmOk = false;
			} else {
				passwordConfirmOk = true;
			}
		}
		
		if(password.val().length !== 0) {
			if (password.val().length < 5) {
				passwordRequirementsOk = false;
				// console.log('pass-length');
			}
			if (!/\d/.test(password.val())) {
				passwordRequirementsOk = false;
				// console.log('pass-numbers');
			}
			if (!/[a-zA-Z]/.test(password.val())) {
				passwordRequirementsOk = false;
				// console.log('pass-letters');
			}
		}
		
		password.add(passwordConfirm).removeClass('success error');
		passwordParent.add(passwordConfirmParent).removeClass('success error');
		if (passwordOk && passwordRequirementsOk) {
			password.addClass('success').removeClass('error');
			passwordParent.addClass('success').removeClass('error');
			$('.form-error-message.password', passwordParent).slideUp(200);
		} else {
			password.removeClass('success').addClass('error');
			passwordParent.removeClass('success').addClass('error');
			$('.form-error-message.password', passwordParent).slideDown(200);
		}
		
		if (passwordConfirmOk) {
			passwordConfirm.removeClass('error');
			passwordConfirmParent.removeClass('error');
			$('.form-error-message.password-check', passwordConfirmParent).slideUp(200);
			
			if (password.val().length !== 0) {
				passwordConfirm.addClass('success');
				passwordConfirmParent.addClass('success');
			}
		} else {
			passwordConfirm.removeClass('success').addClass('error');
			passwordConfirmParent.removeClass('success').addClass('error');
			$('.form-error-message.password-check', passwordConfirmParent).slideDown(200);
		}
		
		if (standalone) {
			t.toggleClass('has-error', !passwordOk || !passwordConfirmOk || !passwordRequirementsOk);
		}
	};

	var formItemsBlur = function (t) {
		var elt = t.target === undefined ? t : $(this);
		var ctn = elt.closest('.form-input');
		var form = ctn.closest('.js-form');

		validateField(elt, form);

		if (form.hasClass('is-checked')) {
			validateForm(form);
		}
	};

	var formCheckChange = function () {
		var t = $(this);
		var ctn = t.closest('.form-checkbox-ctn');
		var form = ctn.closest('.js-form');
		
		if (form.hasClass('is-checked')) {
			validateForm(form);
			
			if (t.is(':checked')) {
				ctn.removeClass('error');
			}
		}
	};

	var checkLabelClick = function () {
		var t = $(this);
		var ctn = t.closest('.register-checkbox');

		if (ctn.hasClass('is-checked')) {
			ctn.removeClass('is-checked');
		} else {
			ctn.addClass('is-checked');
		}
	};

	var toggleCheckbox = function () {
		var t = $(this);
		var ctn = t.closest('.form-input-checkbox');
		var input = $('.form-input-checkbox-input', t);

		if (ctn.hasClass('checked')) {
			ctn.removeClass('checked');
			input.removeAttr('checked');
		} else {
			ctn.addClass('checked');
			input.attr('checked', 'checked');
		}
	};

	var formSwitchClick =function (){
		var t = $(this);
		var elem = $(t).find('.checkbox');

		t.find('.form-checkbox-slider').toggleClass('active');
		if (elem.prop( "checked" )){
			elem.removeAttr( "checked" );
		}else{
			elem.attr( "checked", "checked" );
		}
	};
	
	var updateStateSelect = function () {
		var t = $(this);
		var val = t.val();
		var id = t.attr('data-id');
		var statesCtn = $('.select-state-ctn[data-id="'+id+'"]');
        var selectCtns = $('.form-select-ctn', statesCtn);
        
        var _doSelection = function(claz) {
            selectCtns.filter(claz).addClass('selected')
                .find('.form-select').addClass('selected').attr('name', function() {
                    return !this.hasAttribute('data-name') || this.getAttribute('data-name') === '' 
                        ? this.name : this.getAttribute('data-name');
                });
        };
        
        selectCtns.removeClass('selected')
            .find('.form-select').removeClass('selected');
		selectCtns.find('.form-select').attr('name', function(index, value) {
            if (!this.hasAttribute('data-name') || this.getAttribute('data-name') === '') {
                this.setAttribute('data-name', value);
            }
            return '';
        });
		if (val === 'CA' || val === 'CAN' || val === 'canada' || val === 'Canada') {
            _doSelection('.canada');
		} else if (val === 'US' || val === 'USA' || val === 'United-States' || val === 'united-states') {
            _doSelection('.us');
		} else {
            _doSelection('.other');
		}
	};
	
	var checkIfHasChar = function () {
		var t = $(this);
		var value = $.trim(t.val());
		var ctn = t.closest(t.attr('data-validator-apply-class-on'));
		
		if (value.length !== 0) {
			ctn.add(t).addClass('has-char');
		} else {
			ctn.add(t).removeClass('has-char');
		}
	};
	
	var fileInputChange = function () {
		var t = $(this);
		var label = t.closest('.form-item-upload-input-label');
		var labelDefault = label.attr('data-default-value');
		var labelValue = $('.form-item-upload-input-label-value', label);
		var ctn = t.closest(t.attr('data-validator-apply-class-on'));
		var form = ctn.closest('.js-form');
		var bigCtn = t.closest('.form-input-big-ctn');
		var updateTitle = bigCtn.hasClass('update-title');
		
		if (t.val() !== '') {
			ctn.removeClass('error').addClass('success');
			
			if (updateTitle) {
				labelValue.html(t.val().split('\\')[t.val().split('\\').length - 1]);
			}
		} else if (t.hasClass('required')) {
			ctn.addClass('error').removeClass('success');
			labelValue.html(labelDefault);
		}
		
		if (form.hasClass('is-checked')) {
			validateForm(form);
		}
	};
	
	var initMCE = function () {
		var settings = {
				selector: '.form-wysiwyg',
				menubar: false,
				plugins: 'paste link textcolor lists',
				toolbar: 'formatselect | bold italic strikethrough forecolor | alignleft aligncenter alignright alignjustify  | numlist bullist | link | removeformat',
				entity_encoding: "raw",
				paste_as_text: true
		};
		
		initMCERecur(settings);
	};
	
	
	function initMCERecur (settings) {
			if (typeof tinymce === 'object') {
					tinymce.init(settings);
			} else {
					setTimeout(function () {
						initMCERecur(settings);
					}, 1000);
			}
	}

	var validateAndSubmit = function(t) {
		var form = t.closest('form');
		var showError = false;

		if (t.hasClass('show-error')) {
			showError = true;
		}

		validateForm(form, showError);

		if (!form.hasClass('has-error')) {
			t.addClass('disabled');
			form.submit();
		}
	};
	
	var showSuccessPopup = function(successClass) {
		var success = successClass;
		if (success === undefined) {
			success = 'form-success';
		}
		
		showErrorPopupAnimation(success);
	};
	
	var showErrorPopup = function(errorClass) {
		var error = errorClass;
		if (error === undefined) {
			error = 'form-error';
		}
		
		showErrorPopupAnimation(error);
	};
	
	var showErrorPopupAnimation = function(messageClass) {
		var message = $('.form-popup-message.'+ messageClass);

		$('.form-popup-message').removeClass('show');
		message.addClass('show');
		
		setTimeout(function () {
			message.removeClass('show');
		}, 5000);
	};

	var passwordChecker = function () {
		var t = $(this);
		var name = t.attr('data-strength');
		var progressbar = $('.password-strength-progress-bar#'+name);
		var progressbarCtn = progressbar.closest('.password-strength-ctn');
		
		var strPassword = t.val();
		var charPassword = strPassword.split("");
		var minPasswordLength = 5;
		var baseScore = 0, score = 0;
		
		var num = {};
		num.Excess = 0;
		num.Upper = 0;
		num.Numbers = 0;
		num.Symbols = 0;

		var bonus = {};
		bonus.Excess = 3;
		bonus.Upper = 4;
		bonus.Numbers = 5;
		bonus.Symbols = 5;
		bonus.Combo = 0; 
		bonus.FlatLower = 0;
		bonus.FlatNumber = 0;
		
		for (var i=0; i<charPassword.length;i++) {
			if (charPassword[i].match(/[A-Z]/g)) {num.Upper++;}
			if (charPassword[i].match(/[0-9]/g)) {num.Numbers++;}
			if (charPassword[i].match(/(.*[!,@,#,$,%,^,&,*,?,_,~])/)) {num.Symbols++;} 
		}
		
		num.Excess = charPassword.length - minPasswordLength;
		
		if (num.Upper && num.Numbers && num.Symbols){
			bonus.Combo = 25; 
		}

		else if ((num.Upper && num.Numbers) || (num.Upper && num.Symbols) || (num.Numbers && num.Symbols)) {
			bonus.Combo = 15; 
		}
		
		if (strPassword.match(/^[\sa-z]+$/)) { 
			bonus.FlatLower = -15;
		}
		
		if (strPassword.match(/^[\s0-9]+$/)) { 
			bonus.FlatNumber = -35;
		}
		
		score = baseScore + (num.Excess*bonus.Excess) + (num.Upper*bonus.Upper) + (num.Numbers*bonus.Numbers) + 
		(num.Symbols*bonus.Symbols) + bonus.Combo + bonus.FlatLower + bonus.FlatNumber;
		
		progressbar.width(score+'%');
		
		// progressbar.removeClass('warning secure perfect');
		progressbarCtn.removeClass('warning secure perfect');
		if (score >= 0 && score < 40) {
			// progressbar.addClass('warning');
			progressbarCtn.addClass('warning');
		} else if (score >= 40 && score < 80) {
			// progressbar.addClass('secure');
			progressbarCtn.addClass('secure');
		} else if (score >= 80) {
			// progressbar.addClass('perfect');
			progressbarCtn.addClass('perfect');
		} 
	};
	
	var closeFirmPopup = function () {
		$(this).closest('.form-popup-message').removeClass('show');
		var qkey = this.getAttribute('data-qkey');
		if (qkey && qkey !== '') {
			Fw.component.models().utils.changeURLState(qkey, null, {});
		}
	};
	
	var resetUpload = function (t) {
		var fieldCtn = t.closest('.form-input-big-ctn');
		t.wrap('<form>').closest('form').get(0).reset();
		t.unwrap();
		var defaultLabel = $('.form-item-upload-input-label', fieldCtn).attr('data-default-value');
		$('.form-item-upload-input-label-value', fieldCtn).html(defaultLabel);
		fieldCtn.find('audio').remove();
		fieldCtn.removeClass('error success');
	};

	var init = function (page) {
		body = $('body');
		items = $('.form-input:not([type=file])');

		checkLabel = $('.register-checkbox-label');
		checkboxItems = $('.form-input-checkbox');
		checkboxItemsInner = $('.form-input-checkbox-inner', checkboxItems);
		fileInput = $('.form-input-upload-input', file);
		formSwitch = $('.form-switch');
		formCheck = $('.form-check-input');
		selectCountry = $('.select-country-input');
		file = $('.form-item-upload', currPage);
		fileInput = $('.form-item-upload-input', file);
		validateAndSubmitBtn = $('.validate-and-submit-form-btn');
		passwordField = $('.js-password');
		formPopupCloseBtn = $('.form-popup-message-close-btn');

		checkLabel.click(checkLabelClick);
		checkboxItemsInner.click(toggleCheckbox);
		fileInput.change(fileInputChange);
		formSwitch.click(formSwitchClick);
		formCheck.change(formCheckChange);
		selectCountry.change(updateStateSelect);
		validateAndSubmitBtn.click(function(e) {
			e.preventDefault();
			validateAndSubmit($(this));
		});
		passwordField.keyup(passwordChecker);
		formPopupCloseBtn.click(closeFirmPopup);
		
		initMCE();

		/*items.each(function () {
			if (!$(this).hasClass('no-blur')) {
				$(this).blur(formItemsBlur);
			}
		});*/
		
		items.keyup(checkIfHasChar);
		
		if ($('html').attr('lang') === 'fr') {
			$.datetimepicker.setLocale('fr');
		}
		
		$('.datepicker').each(function () {
			var showTime = $(this).hasClass('show-time');
			var showDate = $(this).hasClass('show-dates');
			var showDateFromToday = $(this).hasClass('show-dates-from-today');
			
			$(this).datetimepicker({
				format: ((showTime ? 'H:i' : '') + (showTime && showDate ? ' ' : '') + (showDate ? 'd-m-Y' : '')),
				step: 15,
				closeOnDateSelect: true,
				timepicker: showTime,
				datepicker: showDate,
				minDate: showDateFromToday ? '0' : '-1970/01/02',
				defaultTime:'12:00'
			});
		});
	};
	
	$(init);


	Fw.component.export('form', {
		init: init,
		validateForm: validateForm,
		showSuccessPopup: showSuccessPopup,
		showErrorPopup: showErrorPopup,
		showErrorPopupAnimation: showErrorPopupAnimation,
		resetUpload: resetUpload,
		validatePassword: validatePassword
	});

})(jQuery);
